export const truncate = (value: string) => {
  if (value.length > 18) {
    return `${value.slice(0, 6)}...${value.slice(-6)}`
  }
  return value
}
